import { Pipe, PipeTransform } from '@angular/core';
import { dayjs } from '@sc/utils';
import { ConfigType } from 'dayjs';

@Pipe({ name: 'parseZoneTimeString', standalone: true })
export class MomentParseZonePipe implements PipeTransform {
  transform(value: ConfigType, timezone: string): string {
    const utcOffset = dayjs(value).utcOffset();
    const momentTime = dayjs(value).utcOffset(utcOffset).tz(timezone);

    if (!momentTime || !momentTime.isValid()) {
      return '';
    }

    const timeString =
      `${momentTime.year()}` +
      '-' +
      ('00' + `${momentTime.month() + 1}`).slice(-2) +
      '-' +
      ('00' + `${momentTime.date()}`).slice(-2) +
      'T' +
      ('00' + `${momentTime.hour()}`).slice(-2) +
      ':' +
      ('00' + `${momentTime.minute()}`).slice(-2) +
      ':' +
      ('00' + `${momentTime.second()}`).slice(-2);

    return timeString;
  }
}
